import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import useRegisterService from '../ApiServices/RegisterService'
import Termandcondition from '../../../assets/termandcondition/termandcondition.pdf'
import '../login/login.scss'
import './register.scss'
import logo from 'src/assets/images/1journey.png'
import art from 'src/assets/images/readingbook.png'

/* --- inline icons --- */
const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

const Register = () => {
  const { formData, formDataError, isLoading, handleSubmit, handleChange } = useRegisterService()
  const [isChecked, setIsChecked] = useState(false)

  const openTerms = (e) => {
    e.preventDefault()
    window.open(Termandcondition, '_blank')
  }

  return (
    <div className="jl jl--auth-tall">
      <ToastContainer />
      <div className="jl__shell">
        {/* ---------- Brand / hero ---------- */}
        <aside className="jl__hero jl__hero--art">
          <div className="jl__aurora" aria-hidden="true">
            <span className="jl__orb jl__orb--a" />
            <span className="jl__orb jl__orb--b" />
            <span className="jl__orb jl__orb--c" />
            <span className="jl__beam" />
            <span className="jl__grid" />
          </div>

          <div className="jl__art">
            <span className="jl__art-glow" aria-hidden="true" />
            <img src={art} alt="A student reading" className="jl__art-img" />
            <div className="jl__art-tag">
              <span>1Journey</span>
              <strong>Stay with us</strong>
            </div>
          </div>
        </aside>

        {/* ---------- Form ---------- */}
        <main className="jl__panel">
          <div className="reg__card">
            <img src={logo} alt="1Journey" className="reg__card-logo" />
            <span className="jl__eyebrow">Get started</span>
            <h2 className="jl__title">Create your account</h2>
            <p className="jl__sub">It only takes a minute. Your roadmap begins here.</p>

            <form onSubmit={handleSubmit} noValidate>
              {/* Student information */}
              <div className="reg__section">
                <div className="reg__section-title">Student information</div>

                <div className="reg__grid">
                  <div className="reg__field">
                    <label htmlFor="studentFirstName">First name</label>
                    <input
                      id="studentFirstName"
                      className={`reg__input${
                        formDataError.studentFirstNameError ? ' reg__input--err' : ''
                      }`}
                      name="studentFirstName"
                      value={formData.studentFirstName}
                      onChange={handleChange}
                      placeholder="First name"
                    />
                    {formDataError.studentFirstNameError && (
                      <span className="reg__err">{formDataError.studentFirstNameError}</span>
                    )}
                  </div>
                  <div className="reg__field">
                    <label htmlFor="studentLastName">Last name</label>
                    <input
                      id="studentLastName"
                      className={`reg__input${
                        formDataError.studentLastNameError ? ' reg__input--err' : ''
                      }`}
                      name="studentLastName"
                      value={formData.studentLastName}
                      onChange={handleChange}
                      placeholder="Last name"
                    />
                    {formDataError.studentLastNameError && (
                      <span className="reg__err">{formDataError.studentLastNameError}</span>
                    )}
                  </div>
                </div>

                <div className="reg__field">
                  <label htmlFor="studentEmail">Email</label>
                  <input
                    id="studentEmail"
                    type="email"
                    className={`reg__input${
                      formDataError.studentEmailError ? ' reg__input--err' : ''
                    }`}
                    name="studentEmail"
                    value={formData.studentEmail}
                    onChange={handleChange}
                    placeholder="student@email.com"
                  />
                  {formDataError.studentEmailError && (
                    <span className="reg__err">{formDataError.studentEmailError}</span>
                  )}
                </div>

                {/* Batch-07: password is no longer set at registration — the student
                    receives an email with a link to set their password. */}
              </div>

              {/* Parent / Guardian information */}
              <div className="reg__section">
                <div className="reg__section-title">Parent / Guardian information</div>

                <div className="reg__grid">
                  <div className="reg__field">
                    <label htmlFor="parentFirstName">First name</label>
                    <input
                      id="parentFirstName"
                      className={`reg__input${
                        formDataError.parentFirstNameError ? ' reg__input--err' : ''
                      }`}
                      name="parentFirstName"
                      value={formData.parentFirstName}
                      onChange={handleChange}
                      placeholder="First name"
                    />
                    {formDataError.parentFirstNameError && (
                      <span className="reg__err">{formDataError.parentFirstNameError}</span>
                    )}
                  </div>
                  <div className="reg__field">
                    <label htmlFor="parentLastName">Last name</label>
                    <input
                      id="parentLastName"
                      className={`reg__input${
                        formDataError.parentLastNameError ? ' reg__input--err' : ''
                      }`}
                      name="parentLastName"
                      value={formData.parentLastName}
                      onChange={handleChange}
                      placeholder="Last name"
                    />
                    {formDataError.parentLastNameError && (
                      <span className="reg__err">{formDataError.parentLastNameError}</span>
                    )}
                  </div>
                </div>

                <div className="reg__field">
                  <label htmlFor="parentEmail">Email</label>
                  <input
                    id="parentEmail"
                    type="email"
                    className={`reg__input${
                      formDataError.parentEmailError ? ' reg__input--err' : ''
                    }`}
                    name="parentEmail"
                    value={formData.parentEmail}
                    onChange={handleChange}
                    placeholder="parent@email.com"
                  />
                  {formDataError.parentEmailError && (
                    <span className="reg__err">{formDataError.parentEmailError}</span>
                  )}
                </div>
              </div>

              {/* Terms */}
              <label className="reg__check">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <span>
                  I accept the{' '}
                  <a href="#terms" onClick={openTerms}>
                    Terms and Conditions
                  </a>
                </span>
              </label>

              <button type="submit" className="jl__btn reg__btn" disabled={!isChecked || isLoading}>
                {isLoading ? (
                  <>
                    <span className="jl__spinner" aria-hidden="true" /> Creating account&hellip;
                  </>
                ) : (
                  <>
                    Create account <ArrowIcon />
                  </>
                )}
              </button>
            </form>

            <p className="reg__foot">
              Already have an account? <Link to="/login">Log in</Link>
            </p>
          </div>
        </main>
      </div>
    </div>
  )
}

export default Register
